module.exports = __webpack_public_path__ + "static/media/tDrive.c7daf96a.svg";